module.exports = __webpack_public_path__ + "img/dot_file.334760e3.gif";